import React from 'react'
import Navbars from '../Navbars'
import Sidebar from './Sidebar'
import hide from "../assets/Hide.png"
import profile from "../assets/profile.png"


const Profile = () => {
    return (
        <>
            <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5" }}>
                <Navbars />
                <div className='d-flex gap-5 pe-3 main_div'>
                    <Sidebar />
                    <div className='inner_div   pt-2 ps-4 pb-5 pe-4 mb-4' style={{ backgroundColor: "white",width:"100%",marginTop:"85px" }}>
                        <p className='feed_heading'>Profile</p>
                        <img style={{ height: "100px", width: "100px", marginTop: "30px" }} src={profile} />
                        <p className='heading1'>Personal Details</p>
                        <div className='row'>
                            <div className='col-lg-8 col-md-12 col-sm-12'>
                                <div className='d-flex gap-2 inputs_div ' style={{ width: "100%" }}>
                                    <div style={{ width: "100%" }}>
                                        <p className='labels'>First Name</p>
                                        <input className='inputs w-100' placeholder='Adam' />
                                    </div>
                                    <div style={{ width: "100%" }}>
                                        <p className='labels'>Second Name</p>
                                        <input className='inputs w-100' placeholder='Adam' />
                                    </div>
                                </div>
                                <div className='d-flex gap-2 inputs_div ' style={{ width: "100%" }}>
                                    <div style={{ width: "100%" }}>
                                        <p className='labels'>Email</p>
                                        <input className='inputs' placeholder='eg@mail.com' />
                                    </div>
                                    <div style={{ width: "100%" }}>
                                        <p className='labels'>Contact</p>
                                        <input className='inputs w-100' placeholder='+149920000222' />
                                    </div>
                                </div>
                                <div className='d-flex gap-2 inputs_div ' style={{ width: "100%" }}>
                                    <div style={{ width: "100%" }}>

                                        <p className='labels' >Address</p>
                                        <input className='inputs' placeholder='xxxxxxxxxxx' />
                                    </div>
                                    <div style={{ width: "100%" }}>
                                        <p className='labels'>Date of Birth</p>
                                        <input className='inputs w-100' placeholder='02-03-1996' />
                                    </div>
                                </div>



                            </div>

                        </div>
                        <div className='row'>
                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                <p className='labels'>Password</p>
                                <p className='labels'>Current Password</p>
                                <div style={{ position: "relative", maxWidth: "600px" }}>
                                    <input className='input2 w-100' placeholder='Message Services' />
                                    <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                                        <img src={hide} />
                                    </div>

                                </div>
                                <p className='labels'>New Password</p>
                                <div style={{ position: "relative", maxWidth: "600px" }}>
                                    <input className='input2 w-100' placeholder='Message Services' />
                                    <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                                        <img src={hide} />
                                    </div>

                                </div>
                                <div className='d-flex justify-content-center' style={{ marginTop: "40px" }}>
                                    <button className='password_btn' >Change Password</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Profile